import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {  CodeListDto } from "@gtpl/shared-models/planning";
import { QcClearanceDTO } from './qc-clearance-dto';

export class QCClearanceResponseModel extends GlobalResponseObject{
    data?: QcClearanceDTO;

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: QcClearanceDTO){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
